import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

export type SaveAction = {
  onSave: () => void;
  disabled: boolean;
} | null;

const SaveActionSetContext = createContext<(action: SaveAction) => void>(
  () => {}
);
const SaveActionReadContext = createContext<SaveAction>(null);

export const CatalogToolbarProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [saveAction, setSaveAction] = useState<SaveAction>(null);
  return (
    <SaveActionSetContext.Provider value={setSaveAction}>
      <SaveActionReadContext.Provider value={saveAction}>
        {children}
      </SaveActionReadContext.Provider>
    </SaveActionSetContext.Provider>
  );
};

export const useSaveAction = () => useContext(SaveActionReadContext);
export const useSetSaveAction = () => useContext(SaveActionSetContext);
